import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import Grid from "@material-ui/core/Grid";
import Collapse from "@material-ui/core/Collapse";
import CheckImg from "Assets/Images/aaa.png";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import { bindActionCreators } from "redux";
import Drawer from "@material-ui/core/Drawer";
import DrawerHeader from "Component/Headers/drawerHeader";
import CallOutNew from "Component/Headers/callOutNew";
import { instance } from "Actions/AxiosInstance";
import { ErrorMessages } from "Constants";
import infoIcon from "Assets/newicons/notify/info/outline/info-outline-16px.svg";
import PageHeader from "Component/Headers/pageHeader";
import DynamicForm from "Component/DynamicForm";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { isSpaceInString } from "Utils";


const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fnfpolicyid: this.props.postData && this.props.postData.fnfpolicyid,
      fnfpolicyname: this.props.postData && this.props.postData.fnfpolicyname,
      ispaiduptolastday:
        this.props.postData && this.props.postData.ispaiduptolastday,
      stoppaymentday: this.props.postData && this.props.postData.stoppaymentday,
      processday: this.props.postData && this.props.postData.processday,
      ispaidencashment:
        this.props.postData && this.props.postData.ispaidencashment,
      ispaidgratuity: this.props.postData && this.props.postData.ispaidgratuity,
      gratuityyear: this.props.postData && this.props.postData.gratuityyear,
      gratuitymonth: this.props.postData && this.props.postData.gratuitymonth,
      isgratuitynonctc:
        this.props.postData && this.props.postData.isgratuitynonctc,
      isincludefromresigned:
        this.props.postData && this.props.postData.isincludefromresigned,
      isViewFormula: false,
      isLearnMore: false,
      open: false,
      right: false,
    };
    this.updatePostData = this.updatePostData.bind(this);
    this.onSave = this.onSave.bind(this);
    this.OnViewFormula = this.OnViewFormula.bind(this);
    this.OnLearnMore = this.OnLearnMore.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  toggleDrawer = (side, open, flag) => () => {
    if (flag === "isViewFormula") {
      this.setState({
        isViewFormula: true,
        isLearnMore: false,
        [side]: open,
      });
    } else if (flag === "isLearnMore") {
      this.setState({
        isViewFormula: false,
        isLearnMore: true,
        [side]: open,
      });
    } else if (!flag) {
      this.setState({
        isViewFormula: false,
        isLearnMore: false,
        [side]: open,
      });
    }
  };

  updatePostData(key, value) {
    this.setState({
      [key]: value,
    });
  }

  componentDidMount() {}

  OnViewFormula() {
    this.setState({
      isViewFormula: true,
      right: true,
    });
  }

  OnLearnMore() {
    this.setState({
      isLearnMore: true,
      right: true,
    });
  }

  onCancel() {
    this.props.enqueueSnackbar(
      "Are you sure? You will lose all unsaved data, if you cancel.",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              this.props.history.push(`${this.props.match.path}`);
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  }

  onSave() {
    if (this.state.fnfpolicyname && !isSpaceInString(this.state.fnfpolicyname)) {
      this.state.fnfpolicyname = this.state.fnfpolicyname.trim();
    }

   if (!this.state.fnfpolicyname) {
      this.props.enqueueSnackbar("Please add policy name", {
        variant: "error",
      });
    } else if (
      this.state.ispaiduptolastday == false &&
      (this.state.stoppaymentday == null ||
        this.state.stoppaymentday.toString() == "")
    ) {
      this.props.enqueueSnackbar("Please add stop payment day", {
        variant: "error",
      });
    } else if (
      this.state.processday == null ||
      this.state.processday.toString() == ""
    ) {
      this.props.enqueueSnackbar("Please add process day", {
        variant: "error",
      });
    } else if (
      this.state.ispaidgratuity == true &&
      (this.state.gratuityyear == null ||
        this.state.gratuityyear.toString() == "")
    ) {
      this.props.enqueueSnackbar("Please enter gratuity year", {
        variant: "error",
      });
    } else if (
      this.state.ispaidgratuity == true &&
      (this.state.gratuitymonth == null ||
        this.state.gratuitymonth.toString() == "")
    ) {
      this.props.enqueueSnackbar("Please enter gratuity month", {
        variant: "error",
      });
    } else {
      const data = {
        fnfpolicyid: this.state.fnfpolicyid,
        fnfpolicyname: this.state.fnfpolicyname,
        ispaiduptolastday: this.state.ispaiduptolastday,
        isincludefromresigned: this.state.isincludefromresigned,
        stoppaymentday: this.state.ispaiduptolastday
          ? null
          : this.state.stoppaymentday,
        processday: this.state.processday,
        ispaidencashment: this.state.ispaidencashment,
        ispaidgratuity: this.state.ispaidgratuity,
        gratuityyear: this.state.ispaidgratuity
          ? this.state.gratuityyear
          : null,
        gratuitymonth: this.state.ispaidgratuity
          ? this.state.gratuitymonth
          : null,
        isgratuitynonctc: this.state.isgratuitynonctc,
      };
      const URL = "payroll/configfnfpolicy";
      instance
        .post(URL, data)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.onCancel();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    return (
      <div className="content-outer-wrapper" style={{ paddingBottom: 92 }}>
        <PageHeader header="Create new FnF policy" />
        <div className="width80">
          <Grid container>
            <Grid item md="12" sm="12">
              <div className="width40">
                <DynamicForm
                  className="width100"
                  fields={textinputconverter({
                    value: this.state.fnfpolicyname,
                    label: "FnF policy name",
                  })}
                  onChange={(val) => this.updatePostData("fnfpolicyname", val)}
                />
              </div>

              <p className="normal-dark-secondary margin-bottom-16">
                Do you want to stop salary payments from the Date of Resignation
                and include it in FNF payments?
              </p>
              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("isincludefromresigned", true);
                }}
                aria-expanded={this.state.isincludefromresigned}
              >
                <span>Yes</span>
                {this.state.isincludefromresigned ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("isincludefromresigned", false);
                }}
                aria-expanded={!this.state.isincludefromresigned}
              >
                <span>No</span>
                {!this.state.isincludefromresigned ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div className="et-level2 width100 margin0">
                <Collapse
                  in={!this.state.isincludefromresigned}
                  timeout={2}
                  unmountOnExit
                  className="padding20 overflow-initial"
                >
                  <div
                    style={{
                      backgroundColor: "#edf5fd",
                      padding: 16,
                      display: "flex",
                    }}
                  >
                    <img src={infoIcon}></img>
                    <p className="normal-dark-secondary margin-left-16">
                      Employee will continue to receive salary during notice
                      period
                    </p>
                  </div>
                </Collapse>
              </div>
              {/* <p className="normal-dark-secondary margin-bottom-16 margin-top-16">
                Should an employee's salary be processed after date of
                resignation upto the last working day?
              </p>
              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("ispaiduptolastday", true);
                }}
                aria-expanded={this.state.ispaiduptolastday}
              >
                <span>
                  Yes, employee will continue to receive salary during notice
                  period
                </span>
                {this.state.ispaiduptolastday ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("ispaiduptolastday", false);
                }}
                aria-expanded={!this.state.ispaiduptolastday}
              >
                <span>No</span>
                {!this.state.ispaiduptolastday ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>

              <div className="et-level2 width100 margin0">
                <Collapse
                  in={!this.state.ispaiduptolastday}
                  timeout={2}
                  unmountOnExit
                  className="padding20 overflow-initial"
                >
                  <div className="depedent-select-list">
                    <p className="normal-dark-secondary margin-bottom-16 margin-top-16">
                      From which day should we stop payments?{" "}
                    </p>
                    <span
                      className="floatleft"
                      style={{ marginRight: 8, width: 80 }}
                    >
                      <DynamicForm
                        fields={integerinputconverter({
                          value: this.state.stoppaymentday,
                          label: "",
                          min: 0,
                          max: 45,
                        })}
                        onChange={(val) =>
                          this.updatePostData("stoppaymentday", val)
                        }
                      />
                    </span>
                    <span className="floatleft" style={{ marginTop: 10 }}>
                      <p className="small-dark-secondary">days.</p>
                    </span>
                    <div className="clear-float"></div>
                  </div>
                </Collapse>
              </div> */}

              <p className="normal-dark-secondary margin-bottom-8 margin-top-16">
                How many days after exit date do you want to process FnF
                payments?
              </p>

              <span className="floatleft" style={{ marginRight: 8, width: 80 }}>
                <DynamicForm
                  fields={integerinputconverter({
                    value: this.state.processday,
                    label: "",
                    min: 0,
                    max: 180,
                  })}
                  onChange={(val) => this.updatePostData("processday", val)}
                />
              </span>
              <span className="floatleft" style={{ marginTop: 10 }}>
                <p className="small-dark-secondary">days.</p>
              </span>
              <div className="clear-float"></div>
              <p className="normal-dark-secondary margin-bottom-16">
                {" "}
                Should leave encashments be calculated and paid for employees at
                the time of FnF settlement?
              </p>

              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("ispaidencashment", true);
                }}
                aria-expanded={this.state.ispaidencashment}
              >
                <span>Yes</span>
                {this.state.ispaidencashment ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div className="et-level2 width100 margin0">
                <Collapse
                  in={this.state.ispaidencashment}
                  timeout={2}
                  unmountOnExit
                  className="padding20 overflow-initial"
                >
                  <div style={{ backgroundColor: "#edf5fd", padding: 16 }}>
                    <div
                      className="margin-bottom-16 "
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: 8,
                      }}
                    >
                      <img
                        src={infoIcon}
                        style={{ paddingLeft: 8, fontSize: 12, marginTop: 2 }}
                      ></img>

                      <p className="normal-dark-secondary padding-left-16">
                        Accumulated leave being encashed by a non govt. employee
                        on his/her retirement is either fully or partially
                        exempted from tax calculation and the tax exemption
                        amount of leave salary will be the LEAST of following:
                      </p>
                    </div>
                    <div
                      className="margin-bottom-16 width80"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: 24,
                        marginTop: 8,
                      }}
                    >
                      <p
                        style={{
                          paddingLeft: 8,
                          fontSize: 12,
                          marginTop: 4,
                          marginLeft: 4,
                        }}
                      >
                        {" "}
                        👉
                      </p>
                      <p
                        style={{ fontSize: 16, paddingLeft: 8 }}
                        className="small-dark-secondary"
                      >
                        {" "}
                        Cash equivalent of unavailed leave calculated on the
                        basis of maximum 30 days for every year of completed
                        service with the current employer
                      </p>
                    </div>
                    <div
                      className="margin-bottom-16 width80"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: 24,
                        marginTop: 8,
                      }}
                    >
                      <p
                        style={{
                          paddingLeft: 8,
                          fontSize: 12,
                          marginTop: 4,
                          marginLeft: 4,
                        }}
                      >
                        {" "}
                        👉
                      </p>
                      <p
                        style={{ fontSize: 16, paddingLeft: 8 }}
                        className="small-dark-secondary"
                      >
                        {" "}
                        {"10 month's ‘Average Salary"}
                      </p>
                    </div>
                    <div
                      className="margin-bottom-16 width80"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: 24,
                        marginTop: 8,
                      }}
                    >
                      <p
                        style={{
                          paddingLeft: 8,
                          fontSize: 12,
                          marginTop: 4,
                          marginLeft: 4,
                        }}
                      >
                        {" "}
                        👉
                      </p>
                      <p
                        style={{ fontSize: 16, paddingLeft: 8 }}
                        className="small-dark-secondary"
                      >
                        {" "}
                        Rs. 3 lakhs (applicable from 1st Apr 1998)
                      </p>
                    </div>
                    <div
                      className="margin-bottom-16 width80"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: 24,
                        marginTop: 8,
                      }}
                    >
                      <p
                        style={{
                          paddingLeft: 8,
                          fontSize: 12,
                          marginTop: 4,
                          marginLeft: 4,
                        }}
                      >
                        {" "}
                        👉
                      </p>
                      <p
                        style={{ fontSize: 16, paddingLeft: 8 }}
                        className="small-dark-secondary"
                      >
                        {" "}
                        Leave encashment actually received at the time of exit
                      </p>
                    </div>
                  </div>
                </Collapse>
              </div>

              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("ispaidencashment", false);
                }}
                aria-expanded={!this.state.ispaidencashment}
              >
                <span>No</span>
                {!this.state.ispaidencashment ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>

              <p className="normal-dark-secondary margin-bottom-16 margin-top-16">
                Would you like to pay accrual Gratuity to employees?
              </p>

              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("ispaidgratuity", true);
                }}
                aria-expanded={this.state.ispaidgratuity}
              >
                <span>Yes</span>
                {this.state.ispaidgratuity ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div className="et-level2 width100 margin0">
                <Collapse
                  in={this.state.ispaidgratuity}
                  timeout={2}
                  unmountOnExit
                  className="padding20 overflow-initial"
                >
                  <div style={{ padding: "0px 16px" }}>
                    <div>
                      <p className="normal-dark-secondary margin-bottom-16">
                        What is the threshold years & months for payment of
                        accrued Gratuity?{" "}
                      </p>
                      <span
                        className="floatleft"
                        style={{ marginRight: 8, width: 80 }}
                      >
                        <DynamicForm
                          fields={integerinputconverter({
                            value: this.state.gratuityyear,
                            label: "",
                            min: 4,
                            max: 100,
                          })}
                          onChange={(val) =>
                            this.updatePostData("gratuityyear", val)
                          }
                        />
                      </span>
                      <span className="floatleft" style={{ marginTop: 10 }}>
                        <p className="small-dark-secondary">years</p>
                      </span>
                      <span
                        className="floatleft"
                        style={{ marginRight: 8, width: 80, marginLeft: 16 }}
                      >
                        <DynamicForm
                          fields={integerinputconverter({
                            value: this.state.gratuitymonth,
                            label: "",
                            min: 0,
                            max: 100,
                          })}
                          onChange={(val) =>
                            this.updatePostData("gratuitymonth", val)
                          }
                        />
                      </span>
                      <span className="floatleft" style={{ marginTop: 10 }}>
                        <p className="small-dark-secondary">months</p>
                      </span>
                      <div className="clear-float"></div>
                      <p className="normal-dark-secondary margin-bottom-16">
                        Would you like to pay Gratuity to employee as a Non-CTC
                        payment and with no-impact on their salary breakdown?
                      </p>
                      <div
                        className="depedent-select-list"
                        onClick={() => {
                          this.updatePostData("isgratuitynonctc", true);
                        }}
                        aria-expanded={this.state.isgratuitynonctc}
                      >
                        <span>Yes</span>
                        {this.state.isgratuitynonctc ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected" />
                        )}
                      </div>
                      <div className="et-level3 width100 margin0">
                        <Collapse
                          in={this.state.isgratuitynonctc}
                          timeout={2}
                          unmountOnExit
                          className="padding20 overflow-initial"
                        >
                          <div>
                            <div
                              style={{ display: "flex" }}
                              className="width100 margin-bottom-8"
                            >
                              <CallOutNew
                                classnames="bg-light-blue width80"
                                header="Want to learn more about how gratuity is calculated?"
                                emoji="💵"
                                textcolor="#1e8ced"
                              />
                              <Button
                                className="btn btn-primary-md-blue margin-left-16"
                                onClick={this.OnViewFormula}
                                style={{ width: 150 }}
                              >
                                {" "}
                                View formula
                              </Button>
                            </div>
                            <div
                              style={{ display: "flex" }}
                              className="width100"
                            >
                              <CallOutNew
                                classnames="bg-light-blue width80"
                                header="Have further questions about Gratuity?"
                                emoji="❓"
                                textcolor="#1e8ced"
                              />
                              <Button
                                className="btn btn-primary-md-blue  margin-left-16 "
                                onClick={this.OnLearnMore}
                                style={{ width: 150 }}
                                variant="contained"
                              >
                                {" "}
                                Learn more{" "}
                              </Button>
                            </div>
                          </div>
                        </Collapse>
                      </div>

                      <div
                        className="depedent-select-list"
                        onClick={() => {
                          this.updatePostData("isgratuitynonctc", false);
                        }}
                        aria-expanded={!this.state.isgratuitynonctc}
                      >
                        <span>No</span>
                        {!this.state.isgratuitynonctc ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected" />
                        )}
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>

              <div
                className="depedent-select-list"
                onClick={() => {
                  this.updatePostData("ispaidgratuity", false);
                }}
                aria-expanded={!this.state.ispaidgratuity}
              >
                <span>No</span>
                {!this.state.ispaidgratuity ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>

              <Drawer
                anchor="right"
                open={this.state.right}
                onClose={this.toggleDrawer("right", false)}
                classes={{
                  paper: "planner-drawer padding15 width30",
                }}
              >
                <DrawerHeader
                  header={
                    this.state.isViewFormula
                      ? "Gratuity formula"
                      : this.state.isLearnMore
                      ? "Learn more"
                      : ""
                  }
                  isbackarrow={false}
                  closeDrawer={this.toggleDrawer("right", false)}
                />
                {this.state.isViewFormula && (
                  <div className="margin-top-8">
                    <p className="small-dark-secondary">
                      Gratuity is calculated differently based on the number of
                      employees.
                    </p>
                    <div style={{ backgroundColor: "#f7f8f8", paddingLeft: 4 }}>
                      <p style={{ color: "#1e8ced", fontSize: 14 }}>
                        {"Employee count > 10"}{" "}
                      </p>
                      <p
                        style={{ fontSize: 14 }}
                        className="small-dark-secondary"
                      >
                        {" "}
                        (15 x Salary x Working Years) / 26{" "}
                      </p>
                    </div>
                    <div style={{ backgroundColor: "#f7f8f8", paddingLeft: 4 }}>
                      <p style={{ color: "#1e8ced", fontSize: 14 }}>
                        {" "}
                        {"Employee Count <= 10 "}{" "}
                      </p>
                      <p
                        style={{ fontSize: 14 }}
                        className="small-dark-secondary"
                      >
                        {" "}
                        {"(15 X Salary x Working Years) / 30"}{" "}
                      </p>
                    </div>
                    <div>
                      <p
                        style={{ fontSize: 14 }}
                        className="small-dark-secondary margin-top-8"
                      >
                        *Remainder period of over 6 months will be counted as 1
                        working year.
                      </p>
                    </div>
                  </div>
                )}
                {this.state.isLearnMore && (
                  <div className="margin-top-8 margin-bottom-40 ">
                    <p className="small-dark-secondary">
                      Gratuity is calculated differently based on the number of
                      employees.
                    </p>
                    <ExpansionPanel
                      style={{
                        boxShadow: "0px 0px 0px",
                        margin: 0,
                        "&$expanded": {
                          margin: 0,
                          minHeight: 40,
                          marginBottom: 0,
                        },
                      }}
                      square
                      key="key"
                      className="expansion-panel-rejected-expense"
                    >
                      <ExpansionPanelSummary
                        style={{
                          height: 40,
                          minHeight: 40,
                          padding: 1,
                        }}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p className="small-dark-secondary">
                          <div className="floatright small-blue t-bold">
                            What is Gratuity?
                          </div>
                          <div className="clearfloat"></div>
                        </p>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails
                        style={{ padding: 2, textAlign: "justify" }}
                      >
                        <div
                          className="width100 thin-scroll"
                          style={{ overflowY: "auto", overflowX: "hidden" }}
                        >
                          <p className="small-dark-secondary">
                            {" "}
                            Gratuity is a cash benefit provided by the employer
                            to an employee in return for services offered by
                            his/her to the company. Companies offer Gratuity to
                            those employees, who work for 5 or more years in the
                            company. Gratuity offer usually at the time when the
                            employee resigned from his job after 5 years, or at
                            the time of retirement of an employee, etc. The
                            employer calculates gratuity through a specific
                            formula or even can pay higher than the calculated
                            amount.
                          </p>
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel
                      style={{
                        boxShadow: "0px 0px 0px",
                        margin: 0,
                        "&$expanded": {
                          margin: 0,
                          minHeight: 40,
                          marginBottom: 0,
                        },
                      }}
                      square
                      key="key"
                      className="expansion-panel-rejected-expense"
                    >
                      <ExpansionPanelSummary
                        style={{
                          height: 40,
                          minHeight: 40,
                          padding: 1,
                        }}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p className="small-dark-secondary">
                          <div className="floatright small-blue t-bold">
                            What is the Gratuity Act, 1972?
                          </div>
                          <div className="clearfloat"></div>
                        </p>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails
                        style={{ padding: 2, textAlign: "justify" }}
                      >
                        <div
                          className="width100 thin-scroll"
                          style={{ overflowY: "auto", overflowX: "hidden" }}
                        >
                          <p className="small-dark-secondary">
                            The payment of Gratuity Act is an act to provide a
                            scheme for payment of gratuity to an employee
                            working factories, companies, mines or shops etc, it
                            is sort of retirement benefits which is intended to
                            help their employees financially. This Act was
                            passed on 21 August 1972 by Indian Parliament.
                          </p>
                          <p className="small-dark-secondary t-bold margin-top-8">
                            Important Points related to Gratuity:
                          </p>
                          <ul className="margin-top-8 margin-bottom-8">
                            <li>
                              <p className="small-dark-secondary">
                                The Employer can reject payment of Gratuity in
                                some cases.
                              </p>
                            </li>
                            <li>
                              <p className="small-dark-secondary">
                                Gratuity up to Rs. 20 Lakh is exempt from Tax.
                              </p>
                            </li>
                            <li>
                              <p className="small-dark-secondary">
                                Contractual employees hired by companies are not
                                eligible to receive Gratuity payment even after
                                they work for more than 5 Years.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel
                      style={{
                        boxShadow: "0px 0px 0px",
                        margin: 0,
                        "&$expanded": {
                          margin: 0,
                          minHeight: 40,
                          marginBottom: 0,
                        },
                      }}
                      square
                      key="key"
                      className="expansion-panel-rejected-expense"
                    >
                      <ExpansionPanelSummary
                        style={{
                          height: 40,
                          minHeight: 40,
                          padding: 1,
                        }}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p className="small-dark-secondary">
                          <div className="floatright small-blue t-bold">
                            When you will receive Gratuity?
                          </div>
                          <div className="clearfloat"></div>
                        </p>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails
                        style={{ padding: 2, textAlign: "justify" }}
                      >
                        <div
                          className="width100 thin-scroll"
                          style={{ overflowY: "auto", overflowX: "hidden" }}
                        >
                          <p className="small-dark-secondary t-bold">
                            These are the situation when you will receive the
                            gratuity payment:
                          </p>
                          <ul className="margin-top-8 margin-bottom-8">
                            <li>
                              <p className="small-dark-secondary">
                                When you resigned from your job after completing
                                5 years in the company.
                              </p>
                            </li>
                            <li>
                              <p className="small-dark-secondary">
                                When you get retired from your job.
                              </p>
                            </li>
                            <li>
                              <p className="small-dark-secondary">
                                When you are at the age of retirement
                                (superannuation).
                              </p>
                            </li>
                            <li>
                              <p className="small-dark-secondary">
                                When you are unable to offer your services to
                                the company in cases like accident, sickness or
                                death.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel
                      style={{
                        boxShadow: "0px 0px 0px",
                        margin: 0,
                        "&$expanded": {
                          margin: 0,
                          minHeight: 40,
                          marginBottom: 0,
                        },
                      }}
                      square
                      key="key"
                      className="expansion-panel-rejected-expense"
                    >
                      <ExpansionPanelSummary
                        style={{
                          height: 40,
                          minHeight: 40,
                          padding: 1,
                        }}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p className="small-dark-secondary">
                          <div className="floatright small-blue t-bold">
                            How Gratuity is Paid?
                          </div>
                          <div className="clearfloat"></div>
                        </p>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails
                        style={{ padding: 2, textAlign: "justify" }}
                      >
                        <div
                          className="width100 thin-scroll"
                          style={{ overflowY: "auto", overflowX: "hidden" }}
                        >
                          <p className="small-dark-secondary">
                            The Employer needs to pay a gratuity amount, within
                            30 days after the retirement, resignation etc by the
                            employee.
                          </p>
                          <p className="small-dark-secondary t-bold margin-top-8">
                            These are the situation when you will receive the
                            gratuity payment:
                          </p>
                          <ul>
                            <li>
                              <p className="small-dark-secondary">
                                An employee can send an application to the
                                organisation regarding the gratuity.
                              </p>
                            </li>
                            <li>
                              <p className="small-dark-secondary">
                                When the Organisation receives the application,
                                they calculate the gratuity amount according to
                                their category.
                              </p>
                            </li>
                            <li>
                              <p className="small-dark-secondary">
                                Then the employer disburses the gratuity amount
                                and sends the details to the employee.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel
                      style={{
                        boxShadow: "0px 0px 0px",
                        margin: 0,
                        "&$expanded": {
                          margin: 0,
                          minHeight: 40,
                          marginBottom: 0,
                        },
                      }}
                      square
                      key="key"
                      className="expansion-panel-rejected-expense"
                    >
                      <ExpansionPanelSummary
                        style={{
                          height: 40,
                          minHeight: 40,
                          padding: 1,
                        }}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p className="small-dark-secondary">
                          <div className="floatright small-blue t-bold">
                            Tax on Gratuity Payment
                          </div>
                          <div className="clearfloat"></div>
                        </p>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails
                        style={{ padding: 2, textAlign: "justify" }}
                      >
                        <div
                          className="width100 thin-scroll"
                          style={{ overflowY: "auto", overflowX: "hidden" }}
                        >
                          <p className="small-dark-secondary">
                            Those who come Under the Payment of Gratuity Act
                            will get the benefits of tax exemption up to Rs. 20
                            lakhs.
                          </p>
                          <p className="small-dark-secondary">
                            Those who come Under the Payment of Gratuity Act
                            will get the benefits of tax exemption up to Rs. 10
                            lakhs.
                          </p>
                          <p className="small-dark-secondary">
                            Gratuity received by government employees at the
                            time of superannuation, retirement etc is fully
                            exempt from tax.
                          </p>
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </div>
                )}
              </Drawer>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 0,
                }}
              >
                <div>
                  <div className="floatleft" style={{ marginLeft: 304 }}>
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn btn-trans"
                      onClick={this.onCancel.bind(this)}
                    >
                      Cancel
                    </Button>
                  </div>
                  <div className="floatright" style={{ marginRight: 72 }}>
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn btn-primary-md-blue"
                      onClick={this.onSave.bind(this)}
                      style={{ marginLeft: 8 }}
                    >
                      Save
                    </Button>
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
              {/* <div className="margin-top-16">
                <Button
                  color="primary"
                  variant="contained"
                  className="btn btn-trans"
                  onClick={this.onCancel.bind(this)}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  className="btn btn-primary-sm-blue"
                  onClick={this.onSave.bind(this)}
                  style={{ marginLeft: 8 }}
                >
                  Save
                </Button>
              </div> */}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(withSnackbar(Create))),
);
